import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CloseIcon = () => {
    return (_jsxs("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M20.3535 0.353516L0.353516 20.3535", stroke: "#000" }), _jsx("path", { d: "M0.353516 0.353516L20.3535 20.3535", stroke: "#000" })] }));
};
export default CloseIcon;
